import { Link, useLocation } from "react-router-dom";
import { Home, Package, Store, ShoppingCart, User } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { useAuth } from "@/contexts/AuthContext";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

const BottomNavigation = () => {
  const { totalItems, setIsCartOpen } = useCart();
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const navItems = [
    {
      label: "Home",
      icon: Home,
      to: "/",
    },
    {
      label: "Shop",
      icon: Package,
      to: "/products",
    },
    {
      label: "Stores",
      icon: Store,
      to: "/stores",
    },
    {
      label: "Cart",
      icon: ShoppingCart,
      onClick: () => setIsCartOpen(true),
      badge: totalItems,
    },
    {
      label: "Profile",
      icon: User,
      to: isAuthenticated ? "/account" : "/auth",
    },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 block border-t border-border/40 bg-background/60 py-2.5 backdrop-blur-lg md:hidden">
      <div className="flex items-center justify-around px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = item.to ? location.pathname === item.to : false;

          const content = (
            <div className="relative flex flex-col items-center gap-1.5 z-10">
              <div className="relative">
                <Icon
                  className={cn(
                    "h-5 w-5 transition-transform duration-200",
                    isActive ? "text-primary scale-105" : "text-muted-foreground"
                  )}
                />
                {item.badge !== undefined && item.badge > 0 && (
                  <span className="absolute -right-2.5 -top-1.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-primary px-1 text-[9px] font-bold text-primary-foreground ring-2 ring-background">
                    {item.badge}
                  </span>
                )}
              </div>
              <span
                className={cn(
                  "text-[10px] font-semibold leading-none transition-colors duration-200",
                  isActive ? "text-primary" : "text-muted-foreground"
                )}
              >
                {item.label}
              </span>
            </div>
          );

          const wrapperClass = "relative group flex flex-1 flex-col items-center py-1.5 outline-none active:scale-95 transition-transform";

          return item.onClick ? (
            <button
              key={item.label}
              onClick={item.onClick}
              className={wrapperClass}
            >
              {content}
            </button>
          ) : (
            <Link
              key={item.label}
              to={item.to!}
              className={wrapperClass}
            >
              {isActive && (
                <motion.div
                  layoutId="activeBottomTab"
                  className="absolute inset-x-3 inset-y-0.5 rounded-xl bg-primary/10"
                  transition={{ type: "spring", stiffness: 380, damping: 30 }}
                />
              )}
              {content}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavigation;
